import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx"
import GlobalHelper from "../GlobalHelper.jsx";
import ActionButton from '../button/actionbutton.component.jsx';
const uuidv4 = require('uuid/v4')

class QuoteCurrency extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            item: this.props.value || null,
            uniqueId: uuidv4(),
            editable: this.props.editable,
            currency: this.props.currency,
            endPoint: this.getEndPoint(this.props),
            editMode: false,
            onChange: this.props.onChange || function () { },
            className: this.props.className || '',
            loading: false,
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.save = this.save.bind(this)
    }

    getEndPoint(props) {
        if (props.mainObject) {
            return '/' + props.mainObject + '/' + props.objectId
        }
        return props.invoiceId ? '/invoices/' + props.invoiceId : '/quotes/' + props.quoteId
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().patch(this.state.endPoint, {
            currency: this.state.currency,
        }).then((r) => {
            this.setState({
                editMode: false,
                loading: false,
            }, () => {
                this.state.onChange(r)
            })
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    render() {
        if (!this.state.editable) {
            return ''
        }

        const currencies = GlobalHelper.getEnabledCurrenciesSelectOptions()
        if (currencies.length === 1) {
            return ''
        }

        return <div className={this.state.className}>
            <p className={'m-0'}>
                <a href={'#'} className="btn btn-outline-primary" aria-expanded="false" onClick={this.triggerEdit}>
                    <Icon value={'money-bill'} className={'mr-1'} />
                    <FormattedMessage
                        id="common.quote.change_currency_btn"
                        defaultMessage="Change currency"
                    />
                </a>
            </p>
            <div className={"dropdown-menu p-4  w-100 mb-3 " + (this.state.editMode ? 'show' : '')} style={{
                position: 'relative'
            }}>
                <p className="m-0 pt-2">
                    <select value={this.state.currency}
                        className="custom-select"
                        onChange={(event) => { this.setState({ currency: event.target.value }) }}
                    >
                        {GlobalHelper.getEnabledCurrenciesSelectOptions()}
                    </select>
                </p>
                <p className="m-0 pt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                        <Icon value={"arrow-left"} />
                    </button>
                    <ActionButton className="btn btn-sm btn-outline-primary ml-2" onClick={this.save} isLoading={this.state.loading}>
                        <Icon value={"save"} />
                    </ActionButton>
                </p>
            </div>
        </div>
    }

}

export default QuoteCurrency





// WEBPACK FOOTER //
// ./src/common/quote/currency.component.jsx